import { serverCache } from '~/server/utils/cache';
import { musicService, type MusicListResponse, type MusicRank, type MusicCategory } from '~/services/musicService';
import { useI18n } from '#imports';
import { localeMappings, type SupportedLocale } from '~/i18n/config';

export function useMusicCache() {
  const { locale } = useI18n();
  const ssrTimeoutMs = import.meta.server ? 2000 : 0;
  
  const getFeaturedMusic = async () => {
    const key = `featuredMusic-${locale.value}`;
    const language = localeMappings.shortToFull[locale.value as SupportedLocale] || 'en_US';
    
    // 使用服务端缓存，ttl设置为1小时
    return await serverCache.get(key, async () => {
      console.log(`[Cache] Getting fresh featured music data for ${key}`);
      const response = await musicService.getFeaturedMusic(undefined, { headers: { 'x-language': language } });
      return response;
    }, 3600, ssrTimeoutMs);
  };
  
  const getCategoryList = async () => {
    const key = `categoryList-${locale.value}`;
    const language = localeMappings.shortToFull[locale.value as SupportedLocale] || 'en_US';
    
    return await serverCache.get(key, async () => {
      console.log(`[Cache] Getting fresh category data for ${key}`);
      const response = await musicService.getCategoryList(undefined, { headers: { 'x-language': language } });
      return response;
    }, 3600, ssrTimeoutMs);
  };
  
  const refreshFeaturedMusic = () => {
    serverCache.invalidateAll('featuredMusic-');
  };
  
  const refreshCategoryList = () => {
    serverCache.invalidateAll('categoryList-');
  };
  
  // 刷新某一语言的所有音乐数据
  const refreshLanguageData = (lang: string) => {
    serverCache.invalidate(`featuredMusic-${lang}`);
    serverCache.invalidate(`categoryList-${lang}`);
  };
  
  return {
    getFeaturedMusic,
    getCategoryList,
    refreshFeaturedMusic,
    refreshCategoryList,
    refreshLanguageData
  };
}
